<template>
  <div>
    <a-select v-if="isEdit === true" :ref="`user${sourceId}`" v-model="value" class="user-select" size="small" show-search :filter-option="utils.filterOption" default-open @blur="isEdit = false" @change="onChange">
      <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
    </a-select>
    <span v-else-if="permission && isEdit === false" class="edit-user" @click="onClick">{{ userValue ? userValue.nickname : '--' }}</span>
    <span v-else>{{ userValue ? userValue.nickname : '--' }}</span>
  </div>
</template>

<script>
import { problemUpdateItem } from '@/api/event/problem';

export default {
  props: {
    item: {
      type: String,
      default: 'handlers'
    },
    sourceId: {
      type: [String, Number],
      default: null
    },
    sourceValue: {
      type: [String, Object],
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      isEdit: false,
      value: null,
      beforeValue: null,
      userValue: null
    };
  },
  computed: {
    userData() {
      return this.utils.getUserData(0);
    },
    permission() {
      return true;
    }
  },
  watch: {
    sourceValue() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.value = this.sourceValue ? this.sourceValue.id : null;
      this.beforeValue = this.sourceValue ? this.sourceValue.id : null;
      this.userValue = this.sourceValue;
    },
    onClick() {
      this.isEdit = true;
      this.$nextTick(() => {
        this.$refs[`user${this.sourceId}`].focus();
      });
    },

    onChange() {
      if (this.beforeValue === this.value) {
        this.isEdit = false;
      } else {
        problemUpdateItem({ id: this.sourceId, item: this.item, value: this.value })
          .then(() => {
            this.isEdit = false;
            this.beforeValue = this.value;
            this.$message.success('更新成功');
            this.userData.forEach(item => {
              if (item.id === this.value) {
                this.userValue = { id: item.id, avatar_url: item.avatar_url, fs_user_id: item.fs_user_id, nickname: item.nickname };
                return;
              }
            });
          })
          .catch(() => {
            this.isEdit = false;
          });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.user-select {
  width: 100%;
}
.edit-user {
  cursor: pointer;
  padding: 0 2px;
  line-height: 22px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.edit-user:hover {
  background-color: #e4e4e4;
}
</style>
